import {
  obtenerSesion,
  PERMISOS,
  puedeAcceder,
  puedeAdministrarClientes,
} from "../../servicios/sesionSeguridad";

export const resolverPermisosPos = (sesion = obtenerSesion()) => {
  const puedeVender = puedeAcceder(PERMISOS.VENTAS_CREAR, sesion);
  return {
    puedeVender,
    puedeCatalogar: puedeAcceder(PERMISOS.MERCADERIAS_ADMINISTRAR, sesion),
    puedeVerClientes: puedeVender || puedeAdministrarClientes(sesion),
    puedeVerPrecios: puedeAcceder(PERMISOS.PRECIOS_VER, sesion),
    puedeVerStock:
      puedeAcceder(PERMISOS.CATALOGOS_VER, sesion) ||
      puedeAcceder(PERMISOS.MERCADERIAS_ADMINISTRAR, sesion),
  };
};
